import {
    BlockWrapper,
    defineBlock,
    useEditor,
    useInspectorControl,
    useToolbar,
    smartProps,
} from '@smartfire/js-block-engine';
import React, { useMemo } from 'react';
import { GuedelonButton } from '../bouton-guedelon/button';
import style from './block.module.scss';
import { useWindowWidth } from '@react-hook/window-size';
import { EditableText } from '@smartfire/components';
import { ReactComponent as SmartfireIcon } from '../assets/smartfire_icone.svg';

const InspectorLazy = React.lazy(() => import('./Inspector'));
const ToolbarLazy = React.lazy(() => import('./Toolbar'));

function Block({ background, link, linkText, imageMobile, type, file, external }) {
    useInspectorControl(InspectorLazy, []);
    const { isEditing, updateData } = useEditor();
    const windowWidth = useWindowWidth();
    const isWide = useMemo(() => {
        const mobileBreakpoint = Number(style.mobileBreakpoint?.split('px')[0] ?? '0');
        return windowWidth >= mobileBreakpoint;
    }, [windowWidth]);
    useToolbar(() => <ToolbarLazy background={background} updateData={updateData} />, [background, updateData]);
    return (
        <BlockWrapper.Div className={style.block}>
            {(isEditing || ((isWide || (!isWide && !imageMobile)) && background)) && (
                <div className={style.background} style={{ backgroundImage: background && `url(${background.url})` }} />
            )}
            {!isEditing && !isWide && imageMobile && (
                <div
                    className={style.background}
                    style={{ backgroundImage: imageMobile && `url(${imageMobile.url})` }}
                />
            )}

            <div className={style.content}>
                <EditableText
                    className={style.title}
                    placeholder={'Entrez un titre'}
                    smartProp="title"
                    tagName="h1"
                    allowedFormats={['core/link']}
                />
                <EditableText
                    className={style.text}
                    placeholder={'Entrez un texte'}
                    smartProp="text"
                    allowedFormats={['core/link']}
                />
                {(isEditing || (link && linkText)) && (
                    <GuedelonButton
                        className={style.guedelonButton}
                        href={isEditing ? null : type ? (file ? file.url : null) : link ? link : null}
                        external={external}
                    >
                        <EditableText tagName="span" placeholder="ajouter un texte" smartProp="linkText" />
                    </GuedelonButton>
                )}
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        background: smartProps.image.withDefault(null),
        imageMobile: smartProps.image.withDefault(null),
        title: smartProps.string.withDefault('Nous bâtissons un château fort'),
        text: smartProps.string.withDefault(''),
        linkText: smartProps.string.withDefault('découvrez l’aventure'),
        link: smartProps.string.withDefault(''),
        file: smartProps.object.withDefault(null),
        external: smartProps.bool.withDefault(false),
        type: smartProps.bool.withDefault(false), //false: link - true: file
    },
    setup: {
        title: 'Home Hero',
        icon: SmartfireIcon,
    },
});
